export enum Core2Config {  
  UNIPIN_PREFIX = 'unipin/',
  UPSTATION_PREFIX = 'upstation/',
  TENANT_MICRO_URL_PREFIX = 'core2/tnt/ms/',
  TENANT_DOMAIN_URL_PREFIX = 'core2/tnt/dm/',
  TENANT_CUSTOM_URL_PREFIX = 'core2/tnt/cm/',
  PLATFORM_DOMAIN_URL_PREFIX = 'core2/platform/dm/'
}
